<div [class]="'animation-hide-message containter-message '" [ngClass]="customClass?customClass:'top-[-50px]'">
    <div class="message rounded-xl"
        [ngClass]="{'bg-[#FA7A6A]': this.status === 'error','bg-[#47ad9f]':this.status === 'success'}">
        <!-- <img *ngIf="this.status === 'error'" src="../../assets/img/x-solid.svg" class="mr-[7.5px]" style="height: 17px;" />
        <img *ngIf="this.status === 'success'" src="../../assets/img/check-solid.svg" class="mr-[10.25px]"
            style="height: 17px" /> -->
        <div class="text-message">{{this.message}}</div>
    </div>
    </div>